module.exports = "img/flags/ME.7054be1.png";